import axios from 'axios';
import { getBaseUrl, getPhpUrl  } from './config';
import { CRM_TOKEN, PT_SCHOOL_LOGIN } from './keys';
import { getCookie, delCookie } from './cookie';
import { message } from 'antd';
import qs from "qs"
import {clearLocalStorage} from "./util";

function goBackSso() {
    localStorage.removeItem('needBackSso')
    let isTest = getBaseUrl().indexOf('test-agent') !== -1;
    let dev = 'test'
    if(!isTest){
        dev = ''
    }
    setTimeout(()=>{
        window.location.href = '//sso-'+ dev + '.songshuai.com';
    },3000)
}
function loginOut () {
    // message.warning('当前登录状态失效 请重新登录')
    // setTimeout(() => {
    //     if (window.crmSocket) {
    //         window.crmSocket.disconnect(true);
    //         window.crmSocket = undefined;
    //     }
    //     localStorage.clear();
    //     sessionStorage.clear();
    //     delCookie(CRM_TOKEN)
    //     window.location.href = '/#/login';
    //     return false;
    // }, 1000)
    const search = qs.parse(decodeURIComponent(window.location.hash).split("?")[1] || "") || {}
    // if (!search.nw || ((window.location.hash.indexOf("#/main/ReportNav/ReportManage") < 0) && (window.location.hash.indexOf("#/main/supervise") < 0))) {
    if (!search.nw || ((window.location.hash.indexOf("#/main/ReportNav/ReportManage") < 0) && (window.location.hash.indexOf("#/main/supervise") < 0)&& (window.location.hash.indexOf("#/main/FeedbackDetails") < 0))) {
        // message.warning('当前登录状态失效 请重新登录')
        const isPublic = localStorage.getItem(PT_SCHOOL_LOGIN);
        const needBackSso = localStorage.getItem('needBackSso');
        setTimeout(() => {
            if (window.crmSocket) {
                window.crmSocket.disconnect(true);
                window.crmSocket = undefined;
            }
            clearLocalStorage();
            sessionStorage.clear();
            delCookie(CRM_TOKEN)
            localStorage.setItem("nav_guidance", "nav_guidance");
            document.body.className="";
            document.querySelector(".Guidance-mask") && document.body.removeChild(document.querySelector(".Guidance-mask"))
            document.querySelector(".Guidance-box") && document.body.removeChild(document.querySelector(".Guidance-box"))
            if(needBackSso) {
                goBackSso()
                return;
            }
            if (isPublic) {
                window.location.href = '/#/pt-login';
            } else {
                window.location.href = '/#/login';
            }
            return false;
        }, 1000)
    }
}
axios.withCredentials = true;
axios.defaults.baseURL = getBaseUrl();
axios.defaults.headers.post['Content-Type'] = "application/json; charset=UTF-8";
axios.interceptors.request.use(function(config) {
    // console.log(config,"@@@");
    let token = getCookie(CRM_TOKEN);
    if (config.url.indexOf('/user/login') === -1 && config.url.indexOf('user/resetPassword') === -1  && (window.location.href.indexOf('login') === -1) && !token) {
        loginOut()
    }
    if ((config.url.indexOf('/user/login') === -1 && config.url.indexOf('user/resetPassword') === -1 && window.location.href.indexOf('/ssologin') === -1) || config.url.indexOf('/user/loginOut')) {
        config.headers.common['Authorization'] = `${token}`;
    }
    return Promise.resolve(config);
}, function(error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(function(response) {
    // 获取token接口不校验，直接返回
    if (response.config.url.indexOf('token') !== -1) {
        return Promise.resolve(response.data);
    }
    // 登录失效
    if (response.data && ((response.data.code === -1) || (response.data.code === 1000))) {
        loginOut()
    } else if(response.data.code === -2){
        // ssologin
        goBackSso();
        // let isTest = getBaseUrl().indexOf('test-agent') !== -1;
        // let dev = 'test'
        // if(!isTest){
        //     dev = ''
        // }
        // setTimeout(()=>{
        //     window.location.href = '//sso-'+ dev + '.songshuai.com';
        // },3000)
    }
    // if (response.data && !!response.data.code) {
    //     !!response.data.message && message.warning(response.data.message)
    // }
    let retData
    if (response.data.code === -1) {
        retData = {
            ...response.data,
            message: '当前登录状态失效 请重新登录'
        }
    } else if (response.data.code === 500) {
        retData = {
            ...response.data,
            message: '服务器开小差了，请稍后重试！'
        }
    } else {
        retData = {
            ...response.data
        }
    }
    return Promise.resolve(retData);
}, function (error) {
    // 获取token接口不校验，直接返回
    if (error.response && error.response.data && ((error.response.data.code === -1) || (error.response.data.code === 1000))) {
        loginOut()
    }
    message.warning('服务器开小差了，请稍后重试！')
    return Promise.reject(error);
})

class CRMAxios{
    constructor(options = {}) {
        this.options = options;
    }
    request(options) {
        return axios.request(options);
    }
    get(url, options = {}) {
        return this.request({
            url: url,
            params: {
                ...options
            }
        })
    }
    phpGet(url, options = {}) {
        return this.request({
            url: getPhpUrl() + url,
            params: {
                ...options
            }
        })
    }
    post(url, data, options = {}) {
        if (data instanceof Object) {
            data = JSON.stringify(data);
        }
        return this.request({
            method: 'post',
            url,
            data,
            ...options
        });
    }
    phpPost(url, data, options = {}) {
        if (data instanceof Object) {
            data = JSON.stringify(data);
        }
        return this.request({
            method: 'post',
            url: getPhpUrl() + url,
            data,
            ...options
        });
    }
}
const instanceAxios = new CRMAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);
export const phpPost = instanceAxios.phpPost.bind(instanceAxios);
export const phpGet = instanceAxios.phpGet.bind(instanceAxios);

